import React, { Component } from "react";
import { connect } from "react-redux";
import i18n from "helpers/i18n";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { withRouter } from "react-router-dom";
import clsx from "clsx";
import BlockButton from "components/UI/BlockButton";
import config from "config/api";
import withWidth from "@material-ui/core/withWidth";
import { withStyles } from "@material-ui/core/styles";
// import LoginForm from 'components/Forms/LoginForm';
import RegistrationForm from "components/Forms/RegistrationTwoStepsForm";
import DialogPopinButton from "components/UI/Dialog/DialogPopinButton";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import IconArrow from "@material-ui/icons/ArrowDropDown";
import { headerBgColor } from "../../helpers/colors";
import Box from "@material-ui/core/Box";
import "react-sticky-header/styles.css";
import HeaderMenu from "./HeaderMenu";

import { fetchData } from "../../ducks/asyncFetcher";

import {
  isLoggedIn,
  getCurrentUserRole,
  getCurrentUserSubRole,
  getCurrentUser,
} from "ducks/authentication";

const AF_KEY = "home";
const styles = (theme) => {
  return {
    root: {

    },
    wrapper: {

    },
    faq: {

    },
    title: {
      fontSize: "3.5rem",
      color: "#fff",
      [theme.breakpoints.down("md")]: {
        fontSize: "2.2rem",
        // textAlign: "center",
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: "2rem",
        textAlign: "center",
      },
      [theme.breakpoints.down("xs")]: {
        fontSize: "1.8rem",
        textAlign: "center",
      },
    },
    headerImage: {
      textAlign: "right",
      [theme.breakpoints.down("sm")]: {
        marginTop: theme.spacing(2),
        textAlign: "center",
      },
    },
  };
};

class HeaderContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      isLogginIn: false,
    };
  }

  render() {
    const { classes } = this.props;
    if (process.env.REACT_APP_SITE === "psy")
      return (
        <Grid container spacing={0} alignItems="center" justify="space-around">
          <Grid item xs={12}>
            <Box align="left">
              <Typography variant={"h1"} className={classes.title}>
                <div>{i18n.get("homeTitle1", { pretty: false })}</div>
                <div>{i18n.get("homeTitle2", { pretty: false })}</div>
              </Typography>
            </Box>
          </Grid>
        </Grid>
      );
    else return <React.Fragment></React.Fragment>;
  }
}

export default withStyles(styles)(HeaderContent);



// WEBPACK FOOTER //
// ./src/components/Header/HeaderContent.jsx